import React, { useEffect, useState } from 'react';
export const StickyWebshopPromo = () => {
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    const handleScroll = () => {
      // Calculate when to hide the sidebar (roughly halfway down the page)
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.scrollHeight;
      const halfwayPoint = documentHeight * 0.5;
      setIsVisible(scrollPosition < halfwayPoint);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed top-24 right-0 z-50 w-52 md:w-56 lg:w-64 hidden md:block" data-id="element-305">
      <div className="bg-white rounded-l-lg shadow-lg border border-gray-200 border-r-0 p-3" data-id="element-306">
        <div className="bg-black text-white text-center py-1 text-sm font-medium mb-2 rounded" data-id="element-307">
          Now delivering to all 50 states and Canada
        </div>
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/i2itGdrzLmTwTx8VDRjsgM/20250705_2100_Jewelry_Display_Focus_remix_01jzektbv8emcb6g8084q9f9c7.png" alt="FRZN Jewelry collection display" className="w-full rounded mb-3" data-id="element-308" />
        <ul className="space-y-2 mb-3" data-id="element-309">
          <li className="flex items-center" data-id="element-310">
            <div className="bg-green-600 rounded-full p-1 mr-2" data-id="element-311">
              <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20" data-id="element-312">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-313" />
              </svg>
            </div>
            <span className="font-medium" data-id="element-314">Handcrafted Jewelry</span>
          </li>
          <li className="flex items-center" data-id="element-315">
            <div className="bg-green-600 rounded-full p-1 mr-2" data-id="element-316">
              <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20" data-id="element-317">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-318" />
              </svg>
            </div>
            <span className="font-medium" data-id="element-319">Fast USA Shipping</span>
          </li>
          <li className="flex flex-col" data-id="element-320">
            <div className="flex items-center" data-id="element-321">
              <div className="bg-green-600 rounded-full p-1 mr-2" data-id="element-322">
                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20" data-id="element-323">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-324" />
                </svg>
              </div>
              <span className="font-medium" data-id="element-325">30-Day-Free Returns</span>
            </div>
            <span className="text-xs text-gray-500 italic ml-7" data-id="element-326">
              *see return policy for details
            </span>
          </li>
          <li className="flex items-center" data-id="element-327">
            <div className="bg-green-600 rounded-full p-1 mr-2" data-id="element-328">
              <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20" data-id="element-329">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-330" />
              </svg>
            </div>
            <span className="font-medium" data-id="element-331">Big Welcome Discounts</span>
          </li>
        </ul>
        <a href="https://frznjewelry.co" target="_blank" rel="noopener noreferrer" className="block bg-black text-white font-bold text-center py-2 rounded hover:bg-gray-800 transition-colors" data-id="element-332">
          SHOP NOW
        </a>
      </div>
    </div>;
};